module.exports = __webpack_public_path__ + "fd4e2a21b13531e1cfb756942d44288b.pdf";